const TreeItemTypes = {
    COLLAPSE_ALL: "TREE_ITEM_COLLAPSE_ALL",
    EXPAND_ALL: "TREE_ITEM_EXPAND_ALL",
    COLLAPSE_OR_EXPAND: "TREE_ITEM_COLLAPSE_OR_EXPAND"
};

export default TreeItemTypes;



// WEBPACK FOOTER //
// ./app/data/TreeItemTypes.js